module.exports = "<div id=\"normalScreen\">\r\n    <normal-mode-option-selection>Loading...</normal-mode-option-selection>    \r\n</div>\r\n<div id=\"expertScreen\">\r\n    <expert-mode-option-selection>Loading...</expert-mode-option-selection>    \r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/selectable-tabs/normal-screen-components/option-selection-panel/option-selection-panel.html
// module id = ./src/app/components/selectable-tabs/normal-screen-components/option-selection-panel/option-selection-panel.html
// module chunks = main